import { frontendURL } from 'dashboard/helper/URLHelper';
import { ROLES, CONVERSATION_PERMISSIONS } from 'dashboard/constants/permissions.js';
import GroupsList from './pages/GroupsList.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/grupos'),
    name: 'whatsapp_groups_index',
    meta: { permissions: [...ROLES, ...CONVERSATION_PERMISSIONS] },
    component: GroupsList,
  },
];
